import { DEFAULT_ROOM_VALIDATION_VIEW_SETTINGS, type IRoomValidationViewSettings } from "@multiconsult-group/multiplacer-core";
import { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "../app/createAppSlice";

export type IDrofusOccurrenceValidationSource = "imported" | "liveDrofus";
export type IDrofusOccurrenceValidationFilterMode = "listType" | "responsibility";

export interface IDrofusOccurrenceValidationState {
  tableFilters: Record<"articles" | "standardRoom", IRoomValidationViewSettings["occurrences"]["tableFilter"]>;
  articleDetailsNumber: string | null;
  articleDetailsSearch: string;
  filterMode: IDrofusOccurrenceValidationFilterMode;
  liveOccurrencesListType: string | null;
  specifiedArticlesListType: string | null;
  specifiedArticlesResponsibility: string | null;
  specifiedArticlesSource: IDrofusOccurrenceValidationSource;
}

const initialState: IDrofusOccurrenceValidationState = {
  tableFilters: { articles: DEFAULT_ROOM_VALIDATION_VIEW_SETTINGS.occurrences.tableFilter, standardRoom: DEFAULT_ROOM_VALIDATION_VIEW_SETTINGS.standardRoom.tableFilter },
  articleDetailsNumber: null,
  articleDetailsSearch: "",
  filterMode: "listType",
  liveOccurrencesListType: null,
  specifiedArticlesListType: null,
  specifiedArticlesResponsibility: null,
  specifiedArticlesSource: "imported",
};

export const drofusOccurrenceValidationSlice = createAppSlice({
  name: "drofusOccurrenceValidation",
  initialState,
  reducers: () => ({
    replaceValidationFiltersInRedux: (state, action: PayloadAction<IRoomValidationViewSettings>) => {
      const value = action.payload;
      state.filterMode = value.occurrences.filterMode;
      state.specifiedArticlesListType = value.occurrences.listType;
      state.specifiedArticlesResponsibility = value.occurrences.responsibility;
      state.tableFilters = { articles: value.occurrences.tableFilter, standardRoom: value.standardRoom.tableFilter };
    },
    setValidationTableFilterInRedux: (state, action: PayloadAction<{
      table: "articles" | "standardRoom"; search?: string; onlyDeviations?: boolean;
    }>) => {
      const { table, ...filter } = action.payload;
      Object.assign(state.tableFilters[table], filter);
    },
    setArticleDetailsNumber: (state, action: PayloadAction<string | null>) => {
      state.articleDetailsNumber = action.payload;
      state.articleDetailsSearch = "";
    },
    setArticleDetailsSearch: (state, action: PayloadAction<string>) => {
      state.articleDetailsSearch = action.payload;
    },
    setDrofusOccurrenceValidationLiveOccurrencesListTypeInRedux: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.liveOccurrencesListType = action.payload;
    },
    setDrofusOccurrenceValidationFilterModeInRedux: (
      state,
      action: PayloadAction<IDrofusOccurrenceValidationFilterMode>
    ) => {
      state.filterMode = action.payload;
    },
    setDrofusOccurrenceValidationListTypeInRedux: (state, action: PayloadAction<string | null>) => {
      state.specifiedArticlesListType = action.payload;
    },
    setDrofusOccurrenceValidationResponsibilityInRedux: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.specifiedArticlesResponsibility = action.payload;
    },
    setDrofusOccurrenceValidationSourceInRedux: (
      state,
      action: PayloadAction<IDrofusOccurrenceValidationSource>
    ) => {
      state.specifiedArticlesSource = action.payload;
    },
  }),
  selectors: {},
});

export const {
  replaceValidationFiltersInRedux,
  setValidationTableFilterInRedux,
  setArticleDetailsNumber,
  setArticleDetailsSearch,
  setDrofusOccurrenceValidationFilterModeInRedux,
  setDrofusOccurrenceValidationLiveOccurrencesListTypeInRedux,
  setDrofusOccurrenceValidationListTypeInRedux,
  setDrofusOccurrenceValidationResponsibilityInRedux,
  setDrofusOccurrenceValidationSourceInRedux,
} = drofusOccurrenceValidationSlice.actions;
